const state = {
  newKey: null,
  nextRoute: null,
  authenticated: null,
};

export default state;
